import React, { useEffect, useState } from "react";

const calc = (target) => {
    const diff = target - new Date().getTime();
    if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
    const d = Math.floor(diff / (1000 * 60 * 60 * 24));
    const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const m = Math.floor((diff / 1000 / 60) % 60);
    const s = Math.floor((diff / 1000) % 60);
    return { d, h, m, s, done: false };
};

const Cell = ({ value, label, testid }) => (
    <div className="flex flex-col items-center" data-testid={testid}>
        <div className="relative w-full">
            <div className="bg-[#14110f] border-2 border-pink-brand px-3 py-4 sm:px-6 sm:py-6 brutal-shadow-yellow">
                <div className="font-display text-4xl sm:text-6xl md:text-7xl text-yellow-brand text-center leading-none tabular-nums">
                    {String(value).padStart(2, "0")}
                </div>
            </div>
        </div>
        <div className="mt-3 font-mono-soft text-[10px] sm:text-xs uppercase tracking-[0.2em] text-[#a19d9a]">
            {label}
        </div>
    </div>
);

export const Countdown = ({ target }) => {
    const targetTime = new Date(target).getTime();
    const [t, setT] = useState(calc(targetTime));

    useEffect(() => {
        const id = setInterval(() => setT(calc(targetTime)), 1000);
        return () => clearInterval(id);
    }, [targetTime]);

    if (t.done) {
        return (
            <div data-testid="countdown-launched" className="font-display text-4xl text-pink-brand uppercase">
                We are LIVE on Pump.fun
            </div>
        );
    }

    return (
        <div data-testid="countdown" className="grid grid-cols-4 gap-3 sm:gap-5 max-w-2xl">
            <Cell value={t.d} label="Days" testid="countdown-days" />
            <Cell value={t.h} label="Hours" testid="countdown-hours" />
            <Cell value={t.m} label="Minutes" testid="countdown-minutes" />
            <Cell value={t.s} label="Seconds" testid="countdown-seconds" />
        </div>
    );
};
